import { NavLink, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "../contexts/AuthProvider";
import { decodeJwtPayload, getEmailFromClaims } from "../utils/jwt";

function titleFromPath(pathname) {
  const map = {
    "/": "Dashboard",
    "/sessions": "Unterhaltungen",
    "/database": "Database",
    "/users": "Users",
    "/settings": "Settings",
  };
  return map[pathname] || "App";
}

const navLinkClass = ({ isActive, forceInactive = false, disabled = false }) =>
  [
    "px-3 py-2 rounded-md text-sm font-medium transition-colors",
    disabled
      ? "text-gray-400 cursor-not-allowed pointer-events-none"
      : (isActive && !forceInactive)
        ? "bg-blue-700 text-white"
        : "text-gray-700 hover:bg-gray-100 hover:text-gray-900",
  ].join(" ");


export default function Navbar() {
  const { token, logOut } = useAuth();
  const { pathname } = useLocation();

  const claims = useMemo(() => decodeJwtPayload(token), [token]);
  const email = useMemo(() => getEmailFromClaims(claims), [claims]);
  const title = useMemo(() => titleFromPath(pathname), [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4">
        <div className="flex h-14 items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="text-base font-semibold text-gray-900">{title}</div>
          </div>

          <div className="flex items-center gap-2">
            <nav className="hidden sm:flex items-end gap-1">
              <NavLink to="/" className={navLinkClass} end>
                Dashboard
              </NavLink>
              <NavLink to="/sessions" className={navLinkClass}>
                Unterhaltungen
              </NavLink>
              <NavLink to="/database" className={navLinkClass}>
                Database
              </NavLink>
              <NavLink to="/users"  aria-disabled="true"
                tabIndex={-1}
                onClick={(e) => e.preventDefault()}
                className={({ isActive }) => navLinkClass({ isActive, disabled: true })}>
                Users
              </NavLink>
              <NavLink to="/settings"  aria-disabled="true"
                tabIndex={-1}
                onClick={(e) => e.preventDefault()}
                className={({ isActive }) => navLinkClass({ isActive, disabled: true })}>
                Settings
              </NavLink>
            </nav>

            <div className="ml-2 hidden md:flex items-center gap-3 border-l border-gray-200 pl-3">
              <div className="max-w-[220px] truncate text-sm text-gray-700" title={email}>
                {email || "unknown user"}
              </div>
              <button
                onClick={logOut}
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
              >
                Logout
              </button>
            </div>

            {/* Mobile fallback: only logout */}
            <button
              onClick={logOut}
              className="md:hidden inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
